/** @format */

export interface GiftCard {
  amount?: any;
  card_number?: any;
  external_key?: any;
  method?: any;
  pay_method_id?: any;
  pin?: any;
  status?: any;
}
